import {connect} from 'react-redux';
import AbstractModalView from './AbstractModalView';

const mapStateToProps = ({
                           locales: {current: currentLocale}
                         }) => ({
  currentLocale
});

export default connect(
  mapStateToProps,
  null
)(AbstractModalView);
